import { Button, Tooltip } from '@civilgrid/ui/components';
import type React from 'react';

interface Props {
  children: React.ReactNode;
  href?: string;
  'data-testid': string;
}

/** Opens an agency's contact-form / PRR page. */
export default function LinkButton({ children, href, 'data-testid': dataTestId }: Props) {
  const button = (
    <Button
      variant="secondary"
      disabled={!href}
      tooltip="Invalid URL"
      data-testid={dataTestId}
      style={{
        background:
          'linear-gradient(to bottom, rgba(255,0,0,0.3), rgba(255,165,0,0.3), rgba(255,255,0,0.3), rgba(0,128,0,0.3), rgba(0,0,255,0.3), rgba(128,0,128,0.3))',
      }}
      onClick={() => {
        if (href) {
          window.open(href, '_blank', 'noopener,noreferrer');
        }
      }}
    >
      {children}
    </Button>
  );

  // A disabled button gets no pointer or focus events, so it explains itself through its own `tooltip`.
  if (!href) return button;
  return (
    <Tooltip asChild text={href}>
      {button}
    </Tooltip>
  );
}
